import MyStepTypes from './mystep.types';
import { getMyStepData } from './mystep.utils';
import { initialMyStepState } from '../initialState';

export const myStepDetails = (state = initialMyStepState, action = {}) => {
	switch (action.type) {
		case MyStepTypes.FETCH_MYSTEP_DETAILS.SUCCESS:
			return Object.assign({}, state, { ...getMyStepData(action.payload) });
		case MyStepTypes.FETCH_REPORT.SUCCESS:
			return Object.assign({}, state, { reportUrl: action.payload });
		default:
			return state;
	}
};
